import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";

import { LorenAsset } from "../loren-assets/interfaces/loren-asset.interface";
import { LorenAssetService } from "../loren-assets/services/loren-asset-service/loren-asset.service";
import { BaseEntityResolver } from "../../shared/resolvers/loren-base-entity-resolver/base-entity.resolver";
import { LorenErrorHandlingService } from "../../shared/services/loren-error-handling-service/loren-error-handling-service.service";

@Injectable()
export class LorenAssetDetailsResolver extends BaseEntityResolver<LorenAsset> {
  protected service: LorenAssetService;
  protected router: Router;
  protected errorHandlingService: LorenErrorHandlingService;

  constructor() {
    const service = inject(LorenAssetService);
    const router = inject(Router);
    const errorHandlingService = inject(LorenErrorHandlingService);

    super(service, "id", router, errorHandlingService);
  
    this.service = service;
    this.router = router;
    this.errorHandlingService = errorHandlingService;
  }
}
